// extracted by mini-css-extract-plugin
module.exports = {"dashboardPie":"style-module__dashboardPie___28LGd","tooltip":"style-module__tooltip___5WVOV","colorBox":"style-module__colorBox___3OniD"};